import { useState, useEffect, FC } from "react";
import NavPill from "./NavPill";

interface NavPillsProps {
    modules: string[];
    contentCallback: (module: string) => void;
}

const renderModuleList = (
    modules: string[],
    onModuleActivate: (module: string) => void,
    activeModule?: string
) => {
    return modules.map((module) => {
        return (
            <NavPill
                key={module}
                module={module}
                isActive={activeModule === module}
                onNavPillClicked={onModuleActivate}
            />
        );
    });
};

const NavPills: FC<NavPillsProps> = ({ modules, contentCallback }) => {
    const [activeModule, setActiveModule] = useState<string>();

    useEffect(() => {
        if (activeModule && modules.indexOf(activeModule) > -1) {
            contentCallback(activeModule);
            return;
        }
        const firstModule = modules[0];
        if (firstModule) {
            setActiveModule(firstModule);
        }
    }, [activeModule, modules, contentCallback]);

    const onModuleActivate = (module: string) => {
        setActiveModule(module);
    };

    return (
        <div className="row">
            <ul className="nav nav-pills">
                {modules?.length
                    ? renderModuleList(modules, onModuleActivate, activeModule)
                    : null}
            </ul>
        </div>
    );
};

export default NavPills;
